<div class="engagement-corporation">
  <div class="engagement-corporation-body">
    <div class="engagement-corporation-body-left">
      <div class="corporation-expand-panel">
        <ul>
          <li class="select-btn" [ngClass]="{'active':showCover}" (click)="showCoverLetter()">Cover Letter</li>
          <li [ngClass]="{'active':showContent}" (click)="showContents()">Contents</li>
        </ul>
      </div>

    </div>
    <div class="engagement-corporation-body-content">

      <ng-container *ngIf="showCover">
        <div class="engagement-corporation-body-content-preview">
          <div class="engagement-corporation-body-content-header">
            <div class=" full-content" >
              <div class="tiny-mc-container"  [innerHtml]="coverHeader | safeHtml"></div>
            </div>
          </div>
          <div class="engagement-corporation-body-content-article" *ngFor="let list of coverLetterArray;let i =index">
            <p *ngIf="list.checked && list.header != Signature">
              <span class="header-label">{{list.header}}</span>
            </p>
            <div class=" sticky-items" *ngIf="list.checked && !list.EditableMode && list.header != 'Signature'">
              <div class="tiny-mc-container" *ngIf="list.header != 'Signature' && !list.EditableMode && list.checked" [innerHtml]="list.content | safeHtml"></div>

              <!--<ng-container>
                <div class="edit ng-star-inserted">
            <i class="fa-regular fa-pen"></i>
                </div>
              </ng-container>-->
            </div>
            <div class=" signature-container sticky-items" *ngIf="list.checked && !list.EditableMode && list.header == 'Signature'">
              <div class="tiny-mc-container " *ngIf="list.header === 'Signature'">
                <!--<p>yours Faithfully</p>-->
                <div>
                  <span class="name-field">
                    <p class="text-flx" >
                        <span class="plain-text">Yours Faithfully</span>
                        <button mat-button class="button-text edit" (click)="editSignHeader()">
                            <i class="fa-regular fa-pen"></i>
                        </button>
                    </p>
                  </span>
                </div>
                <div >
                  <img [src]="signatureSrc" />
                </div>
                <!--<div *ngIf="!signatureSrc">
                  <span class=" signature-container sticky-items">Add Signature</span>
                </div>-->
                <p class="mar-b-8"><span class="edit-label">Name:</span> <span><input class="editable-item" type="text" [(ngModel)]="signatureName" /></span></p>
                <p class="mar-b-8"><span class="edit-label">Designation:</span> <span><input class="editable-item" type="text" [(ngModel)]="signatureDesignation" /></span></p>

              </div>
            </div>
          </div>
          <div class="engagement-corporation-body-content-footer">
            <div class=" sticky-items full-content" >

              <!--<div class="tiny-mc-container"></div>-->
              <div class="tiny-mc-container" *ngIf=" coverFooter" [innerHtml]="coverFooter | safeHtml"></div>

            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="showContent">
        <div class="engagement-corporation-body-content-preview" *ngFor="let l of templateViewArray[0].Content;let i =index">
          <div class="engagement-corporation-body-content-header">
            <div class=" full-content sticky-items dashed-border-head" (click)="openHeaderEditor('content')">
              <div class="tiny-mc-container header-tiny-mc " *ngIf="!headerEditor && headerContent" [innerHtml]="headerContent | safeHtml"></div>
              <ng-container *ngIf="headerEditor">
                <div class="editor-container">
                  <tinymce [(ngModel)]="headerContent" [config]="config"></tinymce>
                  <div class="footer-action-items flex-box-vc-hr">
                    <button mat-raised-button class="secondary-btn" color="secondary" (click)="$event.stopPropagation();cancelHeaderFooterEdit()">Cancel</button>
                    <button mat-raised-button class="secondary-btn" color="primary" (click)="$event.stopPropagation();saveHeaderContent('content')">Save</button>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="engagement-corporation-body-content-article" *ngFor="let list of l.data">
            <p *ngIf="list.checked && list.header">
              <span class="header-label">{{list.header}}</span>
            </p>
            <div class=" sticky-items" *ngIf="list.checked && !list.EditableMode" (click)="openEditor(list)">
              <div class="tiny-mc-container" [innerHtml]="list.content | safeHtml" *ngIf="!list.EditableMode && list.checked"></div>
              <span *ngIf="!list.content && !list.EditableMode">Click here to add content</span>
            </div>
            <ng-container *ngIf="list.EditableMode">
              <tinymce [(ngModel)]="editorContent" [config]="config"></tinymce>
              <div class="footer-action-items flex-box-vc-hr">
                <button mat-raised-button class="secondary-btn" color="secondary" (click)="cancelEdit(list)">Cancel</button>
                <button mat-raised-button class="secondary-btn" color="primary" (click)="saveSelectedContent(list)">Save</button>
              </div>
            </ng-container>
          </div>
          <div class="flex-box-vc-hr">
            <span>{{l.page}} of {{templateViewArray[0].Content.length}}</span>
          </div>
          <div class="engagement-corporation-body-content-footer">
            <div class=" sticky-items" (click)="openFooterEditor('content')">

              <!--<div class="tiny-mc-container"></div>-->
              <div class="tiny-mc-container footer-tiny-mc dashed-border-head" *ngIf="!contentFooterEditor && contentFooter" [innerHtml]="contentFooter | safeHtml"></div>
              <ng-container *ngIf="contentFooterEditor">
                <div class="editor-container">
                  <tinymce [(ngModel)]="contentFooter" [config]="config"></tinymce>
                  <div class="footer-action-items flex-box-vc-hr">
                    <button mat-raised-button class="secondary-btn" color="secondary" (click)="$event.stopPropagation();cancelHeaderFooterEdit()">Cancel</button>
                    <button mat-raised-button class="secondary-btn" color="primary" (click)="$event.stopPropagation();saveFooterContent('content')">Save</button>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

        </div>
      </ng-container>
    </div>
  </div>
</div>


